const messages = {
  AIDOO : {
    title: 'Aidoo',
    desc: 'Dispositivo para la gestión e integración de un equipo de A/A. Opciones: <br/> · Wi-Fi <br/> · KNX',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6xxxxxx.png',
    articles: {
      AIDOO_WIFI: {
        title: 'Aidoo Control Wi-Fi',
        desc: 'Dispositivo para la gestión de un equipo de A/A; control a través de la App Airzone Aidoo, conexión Wi-Fi e integración Modbus',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6WSCxxx.png',
        descResult: 'Controla la configuración de la climatización desde cualquier lugar del mundo a través de la aplicación <b>Airzone Aidoo</b> (disponible para <a href="https://play.google.com/store/apps/details?id=es.airzone.aidoo" target="_blank" style="color:#007f9b">Android</a> e <a href="https://apps.apple.com/app/airzone-aidoo/id1468065088" target="_blank" style="color:#007f9b">iOS</a>). Compatible con:',
        logos: [
          'https://doc.airzone.es/Resources/Images/IMG_logo-Google-Assistant.png',
          'https://doc.airzone.es/Resources/Images/IMG_logo-Alexa.png',
        ],
      },
      AIDOO_KNX: {
        title: 'Aidoo Control KNX',
        desc: 'Dispositivo para la gestión de un equipo de A/A; control KNX TP-1 y 3 entradas digitales configurables',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6KNXxxx.png',
        descResult: 'Gracias a la compatibilidad con el software ETS5, puedes configurar fácilmente Aidoo KNX e incluirlo en tu proyecto. Descargue nuestra <a href="https://doc.airzone.es/producto/Gama_AZ6/Airzone/Aidoo/BBDD_AZAI6KNX.zip" style="color:#007f9b">base de datos</a>.'
      }
    },
    include: {
      protocolo: '%{article} %{protocolo}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a> con:',
      accesrories: [
        'Cable de conexión a la unidad interior.',
        'Tornillos y cinta adhesiva de doble cara para su montaje.',
      ],
    }
  },
  ZONIFIED : {
    title: 'Pasarela para sistema zonificado',
    desc: 'Pasarela para la gestión de un equipo de conducto zonificado',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
    articles: {
      COMMUNICATION_GATEWAY: {
        title: 'Pasarelas de comunicaciones',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
        descResult: '',
      },
    },
    include: {
      pack1: 'Pasarela de comunicaciones Airzone - %{protocolo}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Pasarela controlador 3.0 Airzone - %{protocolo}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  MONOZONE : {
    title: 'Módulo de zona para equipo individual',
    desc: 'Módulo de zona cable/radio para la gestión de un equipo individual',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
    articles: {
      WIRED_ZONE_MODULE: {
        title: 'Módulo de zona cable Airzone',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
        descResult: '',
        conection: 'Cable'
      },
      WIRELESS_ZONE_MODULE: {
        title: 'Módulo de zona radio Airzone',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxR.png',
        descResult: '',
        conection: 'Radio'
      }
    },
    include: {
      pack: '%{name} - %{protocolo}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Kit módulo de zona %{conection} Airzone %{protocolo}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  UNO_SYSTEM : {
    title: 'Pack UNO',
    desc: 'Central + termostato cable/radio para la gestión de un equipo de A/A',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PxxxBFCB.png',
    articles: {
      UNO_BLUEFACE_WHITE: {
        title: 'Pack Airzone UNO Blueface blanco',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCB.png',
        descResult: '',
        type: 'Blueface',
        color: 'Blanco',
        conection: 'Cable'
      },
      UNO_BLUEFACE_BLACK: {
        title: 'Pack Airzone UNO Blueface negro',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCN.png',
        descResult: '',
        type: 'Blueface',
        color: 'Negro',
        conection: 'Cable'
      },
      UNO_THINK_WIRELESS_WHITE: {
        title: 'Pack Airzone UNO Think radio blanco',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRB.png',
        descResult: '',
        type: 'Think',
        color: 'Blanco',
        conection: 'Radio'
      },
      UNO_THINK_WIRELESS_BLACK: {
        title: 'Pack Airzone UNO Think radio negro',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRN.png',
        descResult: '',
        type: 'Think',
        color: 'Negro',
        conection: 'Radio'
      },
      UNO_THINK_WIRED_WHITE: {
        title: 'Pack Airzone UNO Think cable blanco',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCB.png',
        descResult: '',
        type: 'Think',
        color: 'Blanco',
        conection: 'Cable'
      },
      UNO_THINK_WIRED_BLACK: {
        title: 'Pack Airzone UNO Think cable negro',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCN.png',
        descResult: '',
        type: 'Think',
        color: 'Negro',
        conection: 'Cable'
      }
    },
    include: {
      pack: 'Pack Airzone UNO %{protocolo} termostato %{type} (<a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>) con :',
      list1: 'Central Airzone UNO %{type} %{conection} con pasarela de comunicaciones %{protocolo} integrada.',
      list2: 'Termostato Airzone %{type} %{conection} %{color}.',
      list3: 'Cable bus Airzone 10 m.',
      list4: 'Batería de botón CR2450.',
    }
  },
  CompatibilityList: 'Lista de compatibilidades',
  SelectBrand: 'Seleccione su fabricante',
  SelectCompatibilityAirzone: 'Seleccione su dispositivo Airzone',
  SelectAtricleAirzone: 'Seleccione el artículo Airzone',
  SelectIndoorUnitModel: 'Seleccione su modelo de unidad interior',
  ResultUnid: 'Para la unidad %{unid} (%{manufacturer})',
  ResultYourRefer: 'Su referencia Airzone es:',
  NamePdfFile: 'Airzone-referencia-compatibilidad',
  SelectInclude: 'Su selección incluye:',
  ZoneSystem: 'Sistema de zonas',
  MonozoneController: 'Controladores monozona',
  List: 'Listar',
  protocolo: {
    DA0: 'Daikin Residential',
    DA1: 'Daikin Sky Air / VRV',
    DA2: 'Daikin Altherma 3',
    FUJ: 'Fujitsu 3 wires',
    FU2: 'Fujitsu UART',
    GRE: 'Gree U-Match R410A',
    GR1: 'Gree U-Match R32',
    HAI: 'Haier',
    HIT: 'Hitachi RPI',
    HI2: 'Hitachi RAD',
    LGE: 'LG',
    MD1: 'Midea V5 protocol',
    MD2: 'Midea V6 protocol',
    MEL: 'Mitsubishi Electric',
    MHI: 'Mitsubishi Heavy',
    PA0: 'Panasonic RAC Domestic',
    PAN: 'Panasonic',
    TOS: 'Toshiba',
    SAM: 'Samsung',
    SA2: 'Samsung Nasa',
    HS1: 'Hisense',
    BAX: 'Baxi',
    BA1: 'Baxi R32',
    F3V: 'Fancoil 3 velocidades',
    FAN: 'Fancoil',
    IFR: 'IR',
    F10: 'Fancoil 0-10V',
    HI3: 'Hitachi Primairy',
    ME2: 'Mitsubishi Electric Ecodan',
  }
};
export default messages;
